import React from "react";

export const HEXArrowLeft = () => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="c-hex-arrow-left"
    >
      <path
        d="M4.472 1.48793L4.94267 1.01593L4 0.0732646L3.528 0.54393L4.472 1.48793ZM1.33333 3.6826L0.861333 3.2106L0.390667 3.6826L0.861333 4.1546L1.33333 3.6826ZM3.528 6.82126L4 7.29193L4.94267 6.34926L4.472 5.87726L3.528 6.82126ZM3.528 0.54393L0.861333 3.2106L1.80533 4.1546L4.472 1.48793L3.528 0.54393ZM0.861333 4.1546L3.528 6.82126L4.472 5.87726L1.80533 3.2106L0.861333 4.1546ZM1.33333 4.34926L10 4.34926L10 3.01593L1.33333 3.01593L1.33333 4.34926Z"
        fill="#3C3C3C"
      />
    </svg>
  );
};
